import './styles.scss';

type EnvironmentColorIndicatorProps = {
  color: string;
  className?: string;
};

export function EnvironmentColorIndicator({ color, className = '' }: EnvironmentColorIndicatorProps) {
  return (
    <span className={`environment-color-indicator ${className}`.trim()} style={{ backgroundColor: `#${color}` }} />
  );
}
